// extracted by mini-css-extract-plugin
export var Icon = "style-module--Icon--c8559";
export var OurValue = "style-module--OurValue--90bdb";
export var OurValues = "style-module--OurValues--60630";